<style scoped lang="css">
input {
  font-size: 24px;
}

section > main {
  min-height: 420px;
  max-width: 520px;
}
</style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-sm--hover mb-3">
        <Header title="" />
        <b-row class="mb-3 px-3">
          <b-col cols="12" class="mb-3">
            <b-button variant="default" size="sm" @click="goBack">
              <b-icon-chevron-left scale="1.3"></b-icon-chevron-left>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              Ingresa la temperatura que desee convertir, la herramienta la
              convertir&aacute; automaticamente
            </p>
          </b-col>
        </b-row>
        <b-row class="mb-5 px-3 form-container">
          <b-col>
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text>ºF</b-input-group-text>
              </template>
              <b-form-input
                type="number"
                v-model="fahrenheit"
                @update="toCelcius"
              ></b-form-input>
            </b-input-group>
          </b-col>
          <b-col>
            <b-input-group>
              <template v-slot:append>
                <b-input-group-text>ºC</b-input-group-text>
              </template>
              <b-form-input
                type="number"
                v-model="celcius"
                @update="toFahrenheit"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </main>
    </section>
  </div>
</template>

<script>
import Header from "./Header";

export default {
  name: "Temperature",
  components: {
    Header,
  },
  data() {
    return {
      celcius: 45,
      fahrenheit: 113,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toFahrenheit(celcius) {
      this.fahrenheit = Number((celcius * (9 / 5) + 32).toFixed(4));
    },
    toCelcius(fahrenheit) {
      this.celcius = Number((fahrenheit - 32) * (5 / 9).toFixed(4));
    },
  },
};
</script>
